export const paddingLimit = (
  value: string,
  limit: number,
  padding: number = 6,
) => {
  if (!value) {
    return value
  }

  if (value.length > limit) {
    return `${value.slice(0, padding)}...${value.slice(-padding)}`
  }

  return value
}

export const cutEnd = (value: string, limit: number) => {
  if (!value) return value

  if (value.length > limit) {
    return `${value.slice(0, limit)}...`
  }

  return value
}
